module.exports = __webpack_public_path__ + "img/43.fa8efc55.png";